module.exports = __webpack_public_path__ + "static/media/jar-right.9dddb5e6.png";